module.exports = __webpack_public_path__ + "img/validation-new-active.317a063f.svg";